var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#b6b8b9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1702 0.584838C16.4043 -0.194946 15.2553 -0.194946 14.4894 0.584838L8.87234 6.30325L3.25532 0.584838C2.48936 -0.194946 1.34043 -0.194946 0.574468 0.584838C-0.191489 1.36462 -0.191489 2.5343 0.574468 3.31408L6.19149 9.03249L0.574468 14.7509C-0.191489 15.5307 -0.191489 16.7004 0.574468 17.4801C0.957447 17.87 1.46808 18 1.97872 18C2.48936 18 3 17.87 3.38298 17.4801L9 11.7617L14.617 17.4801C15 17.87 15.5106 18 16.0213 18C16.5319 18 17.0426 17.87 17.4255 17.4801C18.1915 16.7004 18.1915 15.5307 17.4255 14.7509L11.8085 9.03249L17.4255 3.31408C17.9362 2.5343 17.9362 1.36462 17.1702 0.584838Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseButton);
export default __webpack_public_path__ + "static/media/modal-close-button.77794a0e.svg";
export { ForwardRef as ReactComponent };